module.exports = __webpack_public_path__ + "img/1_14_1.5d6bf37c.jpg";